import { useCallback, useRef } from 'react';

/** 왼쪽 고정 드로어: 왼쪽으로 스와이프(또는 빠른 왼쪽 플릭) 시 닫기 */
const MIN_DX = 56;
const MIN_HORIZONTAL_BIAS = 14;
const FLICK_PX_PER_MS = 0.38;

export function useSwipeToCloseDrawer(isOpen, onClose) {
  const startXRef = useRef(0);
  const startYRef = useRef(0);
  const startTimeRef = useRef(0);

  const onTouchStart = useCallback(
    (e) => {
      if (!isOpen) return;
      const t = e.touches[0];
      startXRef.current = t.clientX;
      startYRef.current = t.clientY;
      startTimeRef.current = typeof performance !== 'undefined' ? performance.now() : Date.now();
    },
    [isOpen],
  );

  const onTouchEnd = useCallback(
    (e) => {
      if (!isOpen) return;
      const t = e.changedTouches[0];
      const dx = t.clientX - startXRef.current;
      const dy = t.clientY - startYRef.current;
      const now = typeof performance !== 'undefined' ? performance.now() : Date.now();
      const dt = Math.max(now - startTimeRef.current, 16);
      const vx = dx / dt;
      if (Math.abs(dx) <= Math.abs(dy) || Math.abs(dx) < MIN_HORIZONTAL_BIAS) return;
      if (dx < -MIN_DX || vx < -FLICK_PX_PER_MS) onClose();
    },
    [isOpen, onClose],
  );

  return { onTouchStart, onTouchEnd };
}
